<script setup>
import useUserStore from "@/store/modules/user.js";
import { useRoute, useRouter } from 'vue-router'
import { decrypt, encrypt } from "@/utils/jsencrypt.js";
import Cookies from 'js-cookie'
import { LockOutlined, MailOutlined, UserOutlined } from '@ant-design/icons-vue';
import { message } from "ant-design-vue";
import { apiRegister, apiSendCode } from "@/api/common/auth.js";
import ZLoginBg from '@/components/commom/ZLoginBg.vue';
import { isMobileDevice } from '@/utils/common.js';
import { useCountdown } from '@/composables/useCountDown.js';

// const isLogin = ref(true)
const route = useRoute();
const router = useRouter();
const loginFormRef = ref()
const loginForm = ref({
  username: '',
  password: '',
  rememberMe: false,
  confirmPassword: '',
  email: '',
})
//校验规则
const validateConfirmPassword = async (_rule, value) => {
  if (value === '') {
    return Promise.reject('请再次输入密码完成确认');
  } else if (value !== loginForm.value.password) {
    return Promise.reject("两次输入的密码不一致");
  } else {
    return Promise.resolve();
  }
};
const rules = {
  username: [
    { required: true, trigger: 'blur', message: '用户名不能为空' },
    { min: 2, max: 20, message: '用户名长度必须在 2 到 20 个字符之间', trigger: 'blur' }
  ],
  email: [
    { required: true, trigger: 'blur', message: '邮箱不能为空' },
    { type: 'email', message: '请输入正确的邮箱', trigger: ['blur', 'change'] }
  ],
  password: [{ required: true, trigger: 'blur', message: '密码不能为空' },
    { min: 5, max: 20, message: '密码长度必须在 5 到 20 个字符之间', trigger: ['blur', 'change'] }
  ],
  confirmPassword: [{ required: true, trigger: 'blur', message: '请确认密码' },
    {
      validator: validateConfirmPassword,
      trigger: 'change',
    },
  ],
}
const isSendingCode = ref(false);
// const countdown = ref(0);
//
// const startCountdown = () => {
//   let seconds = 60; // 1分钟
//   countdown.value = seconds;
//   const intervalId = setInterval(() => {
//     seconds--;
//     countdown.value = seconds;
//     if (seconds <= 0) {
//       clearInterval(intervalId);
//       countdown.value = 0;
//     }
//   }, 1000);
// };

const getCode = async () => {
  try {
    isSendingCode.value = true;
    await loginFormRef.value.validate('email');
    const email = loginForm.value.email
    await apiSendCode({ email });
    message.success("验证码已发送至邮箱,有效期为3分钟");
    startCountdown();
  } catch ( error ) {
    // message.error("验证码发送失败，请稍后再试");
  } finally {
    isSendingCode.value = false;
  }
};


const handleLogin = async () => {
  await loginFormRef.value.validate();
  if (isLogin.value) {
    // 登录
    try {
      // 勾选了需要记住密码设置在 cookie 中设置记住用户名和密码
      if (loginForm.value.rememberMe) {
        Cookies.set("username", loginForm.value.username, { expires: 30 });
        Cookies.set("password", encrypt(loginForm.value.password), { expires: 30 });
        Cookies.set("rememberMe", loginForm.value.rememberMe, { expires: 30 });
      } else {
        // 否则移除
        Cookies.remove("username");
        Cookies.remove("password");
        Cookies.remove("rememberMe");
      }
      await useUserStore().login(loginForm.value)
      const query = route.query;
      const otherQueryParams = Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
      await router.push({ path: "/", query: otherQueryParams });
      message.success("登陆成功")
    } catch ( error ) {
      console.error('登录失败:', error)
    }
  } else {
    // 注册
    try {
      await apiRegister(loginForm.value);
      message.success("注册成功");
      isLogin.value = true;
    } catch ( error ) {
      console.error('注册失败:', error)
    }
  }
}

const getLoginInfo = () => {
  
  const username = Cookies.get("username")
  const password = Cookies.get("password") ? decrypt(Cookies.get("password")) : ''
  const rememberMe = Cookies.get("rememberMe")
  
  loginForm.value = {
    username, password, rememberMe
  }
}
getLoginInfo()


// 用户操作类型相关逻辑
// 用户操作
const actionIndex = ref(0);
const userActions = [
  { title: '用户登录', subTitle: 'LOGIN' },
  { title: '注册账号', subTitle: 'REGISTER' },
  { title: '找回密码', subTitle: 'RESET' },
]
// 登录操作类型 0:密码登录，1：验证码登录，2：注册账号 3：找回密码
const typeIndex = ref(0);

// 登录标识，密码登录、验证码登陆时，登录标识为true
const isLogin = computed(() => {
  return [0, 1].includes(typeIndex.value);
})

// 改变登录操作
function handleChangeLogin(index) {
  // isLogin.value = code === 0;
  typeIndex.value = index;
  actionIndex.value = index === 2 ? 1 : 0;
  
}

// 忘记密码
function handleForgetPwd() {
  typeIndex.value = 3;
  actionIndex.value = 2;
}

// const countDown = ref(0);
const { countdown, startCountdown } = useCountdown();
const isCountingDown = computed(() => countdown.value > 0);
// 动态计算按钮的文本内容
const contentBtnTitle = computed(() => {
  return isCountingDown.value ? `${countdown.value} 秒后重试` : '获取验证码';
});
async function handleGetVerifyCode(){
  try {
    // isSendingCode.value = true;
    await loginFormRef.value.validate('email');
    const email = loginForm.value.email
    await apiSendCode({ email });
    message.success("验证码已发送至邮箱,有效期为3分钟");
    startCountdown();
  } catch ( error ) {
    // message.error("验证码发送失败，请稍后再试");
  } finally {
    // isSendingCode.value = false;
  }
}


</script>

<template>
  <div class="login">
    
    <div class="login-container">
      <div class="logo-wrapper">
        <div class="logo-img">
          <img src="../../assets/images/logo.png" alt="欢迎使用中职星" />
        </div>
        <div class="title">综合教育平台</div>
      </div>
      <div class="login-outer">
        <div class="login-title">
          <div class="login-title-main">
            {{ userActions[actionIndex].title }}
          </div>
          <div class="login-title-sub">
            {{ userActions[actionIndex].subTitle }}
          </div>
        </div>
        <div class="login-wrapper">
          <div class="login-type-wrapper" v-if="isLogin">
            <div class="login-type" :class="{'is-active': typeIndex === 0}" @click="handleChangeLogin(0)">密码登录</div>
            <a-divider type="vertical"></a-divider>
            <div class="login-type" :class="{'is-active': typeIndex === 1}" @click="handleChangeLogin(1)">验证码登录
            </div>
          </div>
          <a-form
            class="login-form"
            ref="loginFormRef"
            :model="loginForm"
            :rules="rules"
            @submit.prevent="handleLogin"
            labelAlign="left"
            :label-col="{ span: 6 }">
            
            <div class="form-body">
              <a-form-item name="username">
                <a-input size="large"
                         v-model:value="loginForm.username"
                         :maxlength="20"
                         allow-clear
                         placeholder="填写用户名">
                  <template #prefix>
                    <user-outlined />
                  </template>
                </a-input>
              </a-form-item>
              <a-form-item name="email" v-if="!isLogin">
                <a-input size="large"
                         v-model:value.trim="loginForm.email"
                         :maxlength="20"
                         allow-clear
                         placeholder="填写邮箱"
                >
                  <template #prefix>
                    <mail-outlined />
                  </template>
                </a-input>
              </a-form-item>
              <a-form-item name="code" v-if="!isLogin">
<!--                <a-input-group compact style="display: inline-flex">-->
<!--                  <a-input size="large"-->
<!--                           v-model:value.trim="loginForm.code"-->
<!--                           :maxlength="6"-->
<!--                           allow-clear-->
<!--                           placeholder="填写验证码"-->
<!--                  >-->
<!--                    <template #prefix>-->
<!--                      <mail-outlined />-->
<!--                    </template>-->
<!--                  </a-input>-->
<!--                  <a-button type="primary" :loading="isSendingCode" :disabled="isSendingCode || countdown > 0"-->
<!--                            @click="getCode">-->
<!--                    {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}-->
<!--                  </a-button>-->
<!--                </a-input-group>-->
                <a-input-search
                  v-model:value.t.trim="loginForm.code" size="large"
                  placeholder="填写验证码"
                  :enter-button="contentBtnTitle"
                  :maxlength="6"
                  @search="handleGetVerifyCode"
                >
                  <template #prefix>
                    <mail-outlined />
                  </template>
                </a-input-search>
              
              </a-form-item>
              <a-form-item name="password">
                <a-input-password size="large"
                                  v-model:value.trim="loginForm.password"
                                  :maxlength="20"
                                  allow-clear
                                  placeholder="填写登陆密码"
                >
                  <template #prefix>
                    <lock-outlined />
                  </template>
                </a-input-password>
              </a-form-item>
              <a-form-item name="password" v-if="!isLogin">
                <a-input-password size="large"
                                  v-model:value.trim="loginForm.confirmPassword"
                                  :maxlength="20"
                                  allow-clear
                                  placeholder="确认登陆密码"
                >
                  <template #prefix>
                    <lock-outlined />
                  </template>
                </a-input-password>
              </a-form-item>
              <div class="remember-me" v-if="isLogin">
                <a-checkbox v-model:checked="loginForm.rememberMe">
                <span class="action-item">
                  记住我
                </span>
                </a-checkbox>
              </div>
              <div class="action-wrapper">
                
                <a-button class="login-btn" type="primary" block @click="handleLogin">{{ isLogin ? '登陆' : '注册' }}
                </a-button>
                <div class="login-action">
                  <a-button class="action-item" type="link" @click="handleForgetPwd">忘记密码</a-button>
                  <a-button class="action-item" type="link" @click="handleChangeLogin(isLogin ? 2 : 0)">
                    {{ isLogin ? '没有账号？去注册' : '已有账号？去登陆' }}
                  </a-button>
                </div>
                <!--              <div class="action" :class="isLogin? 'action-between': 'action-end'">-->
                <!--                <div class="action-group">-->
                <!--                  -->
                <!--                  -->
                <!--                </div>-->
                <!--              </div>-->
              </div>
            </div>
          </a-form>
        </div>
      </div>
    </div>
    <div class="page-footer">{{ $customerConfig.IPC }}</div>
    <z-login-bg :point-num="isMobileDevice() ? 15 : 30" />
  </div>
</template>
<style lang="scss" scoped>
.login {
  
  .ant-btn-link{
    color:var(--primary-font-color1)
  }
  background: #fff;
  position: relative;
  background: url('@/assets/images/login-bg.png') no-repeat;
  background-position: 0 50%;
  background-size: 70% 80%;
  .ant-form {
    display: flex;
    height: 100%;
    width: 100%;
    .ant-input-affix-wrapper {
      //border-radius: 8px;
      //background: var(--primary-font-color-bg2);
      .ant-input {
        background: transparent !important;
      }
    }
    
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh; // 让容器占据整个视口高度
  overflow: hidden;
  @keyframes raise-down {
    0% {
      transform: translateY(calc(-60% - 24px));
    }
    100% {
      transform: translateY(-60%);
    }
  }
  .page-footer {
    position: absolute;
    bottom: 8px;
    z-index: 2;
    font-size: 14px;
    color: #fff;
  }
  .login-container {
    flex: 1;
    min-height: 200px;
    max-width: 1440px;
    width: 100%;
    height: 80vh;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 10px 50px;
    border-radius: 8px;
    transform: translateZ(1px);
    position: absolute;
    //transform: translate(-50%, -60%);
    //left: 50%;
    //top: 50%;
    z-index: 2;
    .logo-wrapper {
      text-align: center;
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      .logo-img {
        height: 144px;
        overflow: hidden;
      }
      .title {
        font-size: 24px;
        font-weight: bold;
        color: var(--primary-font-weight-color1);
        line-height: 165px;
        text-shadow: var(--shadow-1-active);
      }
    }
    .login-outer {
      height: 100%;
      //animation: raise-down 0.3s linear;
      @extend .flex-column;
      .login-title {
        margin-bottom: 16px;
        & > div {
          position: relative;
          &:before {
            content: '';
            position: absolute;
            z-index: -1;
          }
        }
        &-main {
          font-size: 24px;
          font-weight: bold;
          color: var(--default-font-color1);
          margin-right: 32px;
          padding-left: 16px;
          width: 128px;
          &:before {
            left: -16px;
            bottom: 0;
            height: 8px;
            width: 100%;
            background: var(--primary-font-weight-color5);
          }
        }
        &-sub {
          font-size: 18px;
          font-family: "DIN Bold", sans-serif;
          padding-left: 88px;
          padding-right: 16px;
          margin-left: 32px;
          color: var(--default-font-color3);
          bottom: 20px;
          line-height: 32px;
          width: 160px;
          &:before {
            height: 16px;
            left: 32px;
            bottom: 0;
            width: 90%;
            background: var(--primary-font-weight-bg5);
          }
        }
      }
      .login-wrapper {
        @extend .flex-column;
        min-height: 636px;
        background: #fff;
        border: 1px solid var(--primary-font-color1);
        padding: 24px 36px;
        border-radius: 8px;
        width: 480px;
        box-shadow: var(--shadow-1);
        .login-type-wrapper {
          width: 100%;
          @extend .flex-row;
          margin-bottom: 16px;
          .login-type {
            cursor: pointer;
            font-size: 16px;
            padding: 0 16px;
            color: var(--default-font-color2);
            user-select: none;
            &.is-active, &:hover {
              color: var(--primary-font-color1);
              font-weight: bold;
            }
            &:active {
              transform: translate(1px, 1px);
            }
          }
        }
      }
    }
    .login-form {
      .form-body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
        .remember-me {
          margin-bottom: 24px;
        }
        .action-wrapper {
          flex: 1;
          height: 0;
          @extend .flex-column;
          justify-content: flex-end;
          .login-btn {
            height: 40px;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 16px;
          }
          .login-action {
            @extend .flex-row;
            width: 100%;
            justify-content: space-between;
            .action-item {
              padding: 4px 0;
            }
          }
        }
        .action {
          display: flex;
          align-items: center;
          .action-group {
            > :first-child :after {
              content: '';
              position: absolute;
              height: 1em;
              width: 1px;
              background: #d08b2e;
              bottom: 0;
              transform: translateY(-50%);
              right: -2px;
            }
            .ant-btn {
              padding: 2px 5px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px){
  .login{
    .page-footer{
      color: var(--primary-font-color1);
    }
    .ant-input-group{
      align-items: center;
    }
    .login-container{
      flex-direction: column;
      align-items: center;
      height: 100vh;
      padding: 0;
      .login-outer{
        width: 100%;
        //flex: 1;
        display: flex;
        flex-direction: column;
        height: calc(100% - 70px);
        //justify-content: flex-start;
        .login-wrapper{
          min-height: unset;
          width: 90%;
        }
      }
      .logo-wrapper{
        height: auto;
        flex: 0 1;
        .logo-img{
          width: 88px;
          height: 68px;
          img{
            width: 100%;
          }
        }
        .title{
          line-height: 70px;
          font-size: 18px;
        }
      }
    }
    
  }
  
  
}
.action-between {
  justify-content: space-between;
}

.action-end {
  justify-content: flex-end;
}

.action-item:hover {
  font-weight: bold;
}
</style>